import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PaymentTypeWorkOfferLabel } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-payment-work-offer-lookup',
  templateUrl: './payment-work-offer-lookup.component.html',
  styleUrls: ['./payment-work-offer-lookup.component.css']
})
export class PaymentWorkOfferLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.paymentTypeSelected = [];
    }
  }
  @Input() placeholder = 'Payment Type';
  @Input() isdisabled = false;
  @Input() filterObjValue = 'paymentType';
  @Input() isMultipleSelected = true;
  @Input() viewType = '';

  @Output() getPaymentTypeObj: EventEmitter<any> = new EventEmitter;


  paymentTypeOptionList = [];
  paymentTypeSelected = [];

  /**
   * @constructor
   * Represents a PaymentTypeLookupComponent.
   */
  constructor() {
  }

  ngOnInit() {
    this.paymentTypeOptionList = PaymentTypeWorkOfferLabel;
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.paymentTypeSelected = (preselected && preselected[this.filterObjValue]) ? preselected[this.filterObjValue] : '';
  }

  onPaymentTypeChange() {
    this.getPaymentTypeObj.emit(this.paymentTypeSelected);
  }

  clearPaymentType() {
    this.paymentTypeSelected = [];
    this.getPaymentTypeObj.emit([]);
  }

}
